"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JwtStrategy", {
    enumerable: true,
    get: function() {
        return JwtStrategy;
    }
});
const _common = require("@nestjs/common");
const _passport = require("@nestjs/passport");
const _passportjwt = require("passport-jwt");
const _models = require("~/models");
const _usersservice = require("~/services/users/users.service");
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let JwtStrategy = class JwtStrategy extends (0, _passport.PassportStrategy)(_passportjwt.Strategy) {
    async validate(req, jwtPayload) {
        if (!(jwtPayload == null ? void 0 : jwtPayload.email) || (jwtPayload == null ? void 0 : jwtPayload.is_api_token) || (jwtPayload == null ? void 0 : jwtPayload.is_oauth_token)) return jwtPayload;
        const user = await _models.User.getByEmail(jwtPayload == null ? void 0 : jwtPayload.email);
        if (!user.token_version || !jwtPayload.token_version || user.token_version !== jwtPayload.token_version) {
            _ncError.NcError.unauthorized('Token Expired. Please login again.');
        }
        const userWithRoles = await _models.User.getWithRoles(req.context, user.id, {
            user,
            baseId: req.ncBaseId
        });
        return userWithRoles && _extends({}, userWithRoles, {
            isAuthorized: true
        });
    }
    constructor(options, userService){
        super(_extends({
            expiresIn: '10h'
        }, options)), this.userService = userService;
    }
};
JwtStrategy = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0,
        typeof _usersservice.UsersService === "undefined" ? Object : _usersservice.UsersService
    ])
], JwtStrategy);
